<!--
  description: set Status of a Learning Activity
  todo: remodel to use mapState, make it generic
-->
<template>
  <div>
    <ElRow>
      <ElCol>
        <select
          v-model="selected"
          @change="
            (event) => {
              $emit('input', event.target.value)
            }
          "
        >
          <option value="" selected disabled>
            Set status...
          </option>

          <option :key="o" :value="o" v-for="o in options">
            {{ o }}
          </option>
        </select>
      </ElCol>
    </ElRow>
  </div>
</template>
<script>
export default {
  name: "HiStatus",
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  mounted() {
    this.selected = this.value
  },

  computed: {
    options() {
      return ["public", "private"]
      // return this.$store.getters["admin/forms"]["status"]
    },
  },

  data() {
    return {
      selected: "",
    }
  },
}
</script>
